import { AfterViewInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { PlatformService } from '@app/services/platform.service';
import { Subscription } from 'rxjs';

declare var $: any;
declare function dropdownInputFilter(): void;
declare function clearInputDropdown(): void;

@Component({
  selector: 'form-group-checkbox-multi',
  templateUrl: './form-group-checkbox-multi.component.html',
  styleUrls: ['./form-group-checkbox-multi.component.css']
})
export class FormGroupCheckboxMultiComponent implements AfterViewInit {

  @Input() controlArray: FormArray;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() footer: string = '';
  @Input() placeholderSearch: string = '';
  @Input() dataSelectLabel: Array<string> = [];
  @Input() enabledCountControl: boolean = false;
  @Input() onlyAvailableFilter: boolean = false;
  @Input() enabledFilter: boolean = true;
  @Input() style: 'purple' | 'default' = 'default';
  @Input() disabled: boolean = false;
  @Input() showValuesOnPlaceholder: boolean = false;
  @Input() textSelectAllGroup: string = '';
  @Input() tooltip: string | undefined = undefined;
  public countSelectedValues: number = 0;

  private subscriptionControl: Subscription;


  constructor(private platformService: PlatformService) {

  }

  ngAfterViewInit() {
    this.initComponent();
  }

  initComponent() {
    if (this.platformService.isPlatformServer)
      return;

    $(`#${this.id}-search`).keyup(dropdownInputFilter);
    $(`#${this.id}-dp`).on('hidden.bs.dropdown', clearInputDropdown);
    $(`#${this.id}-dp`).on('show.bs.dropdown',
      () => {
        setTimeout(() => {
          $(`#${this.id}-search`).focus()
        }, 0);
      });

    if (this.showValuesOnPlaceholder && !this.subscriptionControl) {
      this.subscriptionControl = this.controlArray.valueChanges.subscribe(() => {
        this.getCountSelectedValues();
      })
    }
  }

  onChangeCheckboxAll(event: any) {
    this.controlArray.controls.forEach((e: FormControl) => e.setValue(event.target.checked === true, { emitEvent: false }));
    this.controlArray.markAllAsTouched();
    this.controlArray.updateValueAndValidity();
  }

  getCountSelectedValues() {

    this.countSelectedValues = this.controlArray.value.map((checked, i) => checked ? this.dataSelectLabel[i] : null).filter(v => v !== null).length;

    const checkSelectAll = document.getElementById(`${this.id}-all`) as HTMLInputElement;

    const lenghtTrue = this.controlArray.controls.filter((e: FormControl) => e.value === true).length;

    checkSelectAll.checked = lenghtTrue === this.controlArray.length;
  }

  onRemoveOption(event: MouseEvent, index: number) {
    event.stopPropagation();
    this.controlArray.controls[index].setValue(false);
  }

  ngOnDestroy() {
    if (this, this.subscriptionControl) { this.subscriptionControl.unsubscribe(); }
  }

}
